export const CREATE_LEAD_PROFILE_LEAD_FINANCE = 'CREATE_LEAD_PROFILE_LEAD_FINANCE';
export const CREATE_LEAD_PROFILE_LEAD_FINANCE_SUCCESS = 'CREATE_LEAD_PROFILE_LEAD_FINANCE_SUCCESS';
export const CREATE_LEAD_PROFILE_LEAD_FINANCE_FAILURE = 'CREATE_LEAD_PROFILE_LEAD_FINANCE_FAILURE';

export const READ_LEAD_PROFILE_LEAD_FINANCE = 'READ_LEAD_PROFILE_LEAD_FINANCE';
export const READ_LEAD_PROFILE_LEAD_FINANCE_SUCCESS = 'READ_LEAD_PROFILE_LEAD_FINANCE_SUCCESS';
export const READ_LEAD_PROFILE_LEAD_FINANCE_FAILURE = 'READ_LEAD_PROFILE_LEAD_FINANCE_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/lead_profile_lead_finance.constants.js